import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GrecaptchaService {
  private readonly _SITE_KEY = environment.GRECAPTCHA_SITE_KEY;
  private _readyPromise: Promise<void> | null = null;

  constructor(@Inject(PLATFORM_ID) private _platformId: object) {
    this.ensureReady();
  }

  private ensureReady(): Promise<void> {
    if (isPlatformServer(this._platformId) || !environment.GRECAPTCHA_ENABLED) {
      return new Promise((resolve) => resolve());
    }

    if (this._readyPromise) return this._readyPromise;

    this._readyPromise = new Promise<void>((resolve, reject) => {
      if ((window as any).grecaptcha && (window as any).grecaptcha.execute) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${this._SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if ((window as any).grecaptcha && (window as any).grecaptcha.ready) {
          (window as any).grecaptcha.ready(() => resolve());
        } else {
          resolve();
        }
      };
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });

    return this._readyPromise;
  }

  execute(action: string): Observable<string> {
    return from(
      this.ensureReady().then(() => {
        const grecaptcha = (window as any).grecaptcha!;
        return grecaptcha.execute(this._SITE_KEY, { action });
      })
    );
  }
}
